module.exports = __webpack_public_path__ + "img/Application_platform_pic02.6a093d54.jpg";